module.exports = __webpack_public_path__ + "media/components/Sponsors/Shared/Buttons/Round/eye-18f989d8197184a82b295ecd13e2b6b8.svg";